export default {"src":"/_next/static/media/menu.ff9df6c3.svg","height":37,"width":37};